import { render, staticRenderFns } from "./ReportStatistics.vue?vue&type=template&id=7d87d672"
import script from "./ReportStatistics.vue?vue&type=script&lang=js"
export * from "./ReportStatistics.vue?vue&type=script&lang=js"
import style0 from "./ReportStatistics.vue?vue&type=style&index=0&id=7d87d672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports